// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"efc05f56","154":"b5de1780","352":"8604b9bd","559":"b5de1780","758":"872040fc","769":"872040fc","841":"b5de1780","914":"872040fc"}[chunkId] + ".chunk.css";
};